export type NotificationFilters = {
  SHOW_PLANNED_MAINTENANCE: Boolean;
  SHOW_SERVICE_TICKETS: Boolean;
  SHOW_DCIM_ALERTS: Boolean;
};

export type NotificationDateFilters = {
  FROM_DATE?: Date;
  TO_DATE?: Date;
};

export type ConfirmationDialogEventDetail = {
  returnValue: Boolean;
};

export type FilterDialogEventDetail = {
  returnValue: Boolean;
};
